import { HomeOutlined } from "@ant-design/icons"
import { Breadcrumb, ConfigProvider, theme } from "antd"
import React from "react"
import { Link, useLocation } from "react-router-dom"
import bannersStore from "../../stores/bannersStore"

const MyBreadcrumb = () => {
    const location = useLocation()
    const selectedBanner = bannersStore((state) => state.selectedBanner)

    // Split the pathname into segments
    const pathSnippets = location.pathname.split("/").filter((i) => i)

    const breadcrumbItems = [
        {
            title: (
                <Link to="/banners">
                    <HomeOutlined />
                </Link>
            ),
        },
    ]

    pathSnippets.includes("banner-editor") &&
        breadcrumbItems.push(
            selectedBanner ? { title: `ویرایش بنر ${selectedBanner.id}` } : { title: "ساخت بنر" }
        )

    return (
        <ConfigProvider
            direction="rtl"
            theme={{
                algorithm: theme.darkAlgorithm,
                components: {
                    Breadcrumb: {
                        itemColor: "#fff",
                        iconFontSize: 16,
                    },
                },
            }}
        >
            <Breadcrumb
                className="pr-10 pt-5"
                style={{ fontSize: "16px" }}
                items={breadcrumbItems}
            />
        </ConfigProvider>
    )
}

export default MyBreadcrumb
